/**
 * Orderopatorio
 *
 * The version of the OpenAPI document: 0.15.6-SNAPSHOT
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const MenuType = {
  Breakfast: 'BREAKFAST',
  Dinner: 'DINNER',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MenuType = typeof MenuType[keyof typeof MenuType];
